import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import Api from '../api/api';
import Loader from '../shared/loader';
import { saveAs } from 'file-saver';
import Pagination from '../shared/pagination';
import Modal from 'react-bootstrap/Modal';
import arrayUtilities from '../../utilities/arrayUtilities';
import roleUtilities from '../../utilities/roleUtilities';
import stringHelpers from '../../utilities/stringHelpers';
import {isDateTimeElapsed, toDateTimeString} from '../../utilities/dateUtilities';
import {allowedVrmEnableDisable} from '../../utilities/allowListUtilities';
import { ColumnSortTrigger } from '../shared/columnSortTrigger';
import { ErrorModal } from '../../utilities/errorModal';
import { ToggleWithLocalisedLoading } from '../shared/toggleWithLocalisedLoading';
import { renderValidity } from '../../utilities/allowListUtilities';
import { AppliedFilterPill, renderTagFilterItemLabel } from '../shared/appliedFilterPill';
import appliedFiltersUtilities from '../../utilities/appliedFiltersUtilities';
import { AllowListFiltersModal } from '../shared/allowListFiltersModal';
import { SearchBarWithDebounce } from '../shared/searchBarWithDebounce';
import { FiltersModalTrigger } from '../shared/filtersModalTrigger';
import { AllowListScheduleModal } from '../reports/schedule-modals/allowListScheduleModal';

function AllowList(props) {
    const [allowList, setAllowList] = useState(null);
    const [count, setCount] = useState(null);
    const [siteId, setSiteId] = useState(null);
    const [clientId, setClientId] = useState(null);
    const [sitesByClient, setSitesByClient] = useState(props.sites);
    const [search, setSearch] = useState("");
    const [createdByUserId, setCreatedByUserId] = useState(null)
    const [createdBySource, setCreatedBySource] = useState(null)
    const [createdByOptions, setCreatedByOptions] = useState([])
    const [selectedTags, setSelectedTags] = useState([])
    const [filterEnd, setFilterEnd] = useState(null);
    const [filterStart, setFilterStart] = useState(null);
    const [globalOnly, setGlobalOnly] = useState(false)
    const [datePreset, setDatePreset] = useState(null);

    const [filterPeriodType, setFilterPeriodType] = useState("0");

    const [currentSortBy, setCurrentSortBy] = useState(stringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`).sortBy);

    const [pageNumber, setPageNumber] = useState(0);
    const [multiDeleteList, setMultiDeleteList] = useState([]);
    const [showDeleteModal, setShowDeleteModal] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [errorMessage, setErrorMessage] = useState(false)
    const [showFiltersModal, setShowFiltersModal] = useState(false);
    const [showFilterPills, setShowFilterPills] = useState(false);
    const [appliedFilters, setAppliedFilters] = useState(null);
    const [showScheduleExportModal, setShowScheduleExportModal] = useState(false);

    const scheduleDateParameters = datePreset !== null
        ? { reportDatePreset: datePreset }
        : { from: filterStart, to: filterEnd }

    const scheduleInitialParameters = {
        ...scheduleDateParameters,
        siteId: siteId,
        clientId: clientId,
        userId: createdByUserId,
        createdBySource: createdBySource,
        allowedVrmFilterDateType: Number(filterPeriodType),
        tagIds: selectedTags,
    }

    const openScheduleExportModal = () => setShowScheduleExportModal(true)

    const closeScheduleExportModal = () => setShowScheduleExportModal(false)

    const isThirdPartyUser = roleUtilities.isThirdPartyProcessor(props.user, props.organisationId) || roleUtilities.isThirdPartyManager(props.user, props.organisationId)
    
    const exportToCSV = () => {
        const sortPreference = stringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
        Api.exportAllowListCsv(
            props.organisationId,
            search,
            filterStart,
            filterEnd,
            !stringHelpers.isNullOrEmpty(siteId) ? siteId : null,
            Number(filterPeriodType),
            sortPreference.sortBy,
            sortPreference.sortDirection,
            !stringHelpers.isNullOrEmpty(createdByUserId) ? createdByUserId : null, 
            !stringHelpers.isNullOrEmpty(createdBySource) ? createdBySource : null,
            selectedTags,
            globalOnly,
            !stringHelpers.isNullOrEmpty(clientId) ? clientId : null,
            (blob, filename) => saveAs(blob, filename),
            error => console.log(error),
            props.token
        );
    };

    const changePageNumber = function (num) {
        setPageNumber(num);
        const sortPreference = stringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
        getAllowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, num, createdByUserId, createdBySource, selectedTags, globalOnly, clientId)
    };

    const getAllowList = function (searchQuery, from, to, siteId, filterPeriodType, sortBy, sortDirection, page, user, source, tagIds, isGlobalOnly, clientId) {
        
        setIsLoading(true)
        Api.searchAllowedVrms(
            (data) => {
                if (data !== null) {
                    setAllowList(data.items);
                    setCount(data.totalCount);
                }
                setIsLoading(false)
            },
            (error) => {
                console.log(error)
                setIsLoading(false)
            },
            0,
            page,
            searchQuery,
            null,
            from,
            to,
            null,
            siteId,
            Number(filterPeriodType),
            sortBy,
            sortDirection,
            !stringHelpers.isNullOrEmpty(user) ? user : null,
            !stringHelpers.isNullOrEmpty(source) ? source : null,
            tagIds,
            isGlobalOnly,
            !stringHelpers.isNullOrEmpty(clientId) ? clientId : null,
            props.organisationId,
            props.token,
            true
        );
    };

    const clearFilters = function () {
        setSiteId(null);
        setClientId(null);
        setSitesByClient(props.sites);
        setFilterStart(null);
        setFilterEnd(null);
        setGlobalOnly(false)
        setDatePreset(null);
        setCreatedByUserId(null);
        setCreatedBySource(null);
        setSelectedTags([]);
        setAppliedFilters(null);
        setShowFilterPills(false);
        setFilterPeriodType("0");
        setPageNumber(0);
        const sortPreference = stringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
        getAllowList(search, null, null, null, "0", sortPreference.sortBy, sortPreference.sortDirection, 0, null, null, [], false, null)
    };

    const clearFilterByLabel = (label) => {
        const sortPreference = stringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
        switch (label) {
            case "Client":
                setClientId(null)
                setSitesByClient(props.sites)
                setSiteId(null)
                getAllowList(search, filterStart, filterEnd, null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, createdByUserId, createdBySource, selectedTags, globalOnly, null)
                break
            case "Site":
                setSiteId(null)
                getAllowList(search, filterStart, filterEnd, null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, createdByUserId, createdBySource, selectedTags, globalOnly, clientId)
                break
            case "Created By":
                setCreatedByUserId(null)
                setCreatedBySource(null)
                getAllowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, null, null, selectedTags, globalOnly, clientId)
                break
            case "Period Type":
                setFilterPeriodType("0")
                getAllowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, "0", sortPreference.sortBy, sortPreference.sortDirection, 0, createdByUserId, createdBySource, selectedTags, globalOnly, clientId)
                break
            case "From":
                setFilterStart(null)
                getAllowList(search, null, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, createdByUserId, createdBySource, selectedTags, globalOnly, clientId)
                break
            case "To":
                setFilterEnd(null)
                getAllowList(search, filterStart, null, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, createdByUserId, createdBySource, selectedTags, globalOnly, clientId)
                break
            case "Date Range":
                setFilterStart(null)
                setFilterEnd(null)
                setDatePreset(null)
                getAllowList(search, null, null, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, createdByUserId, createdBySource, selectedTags, globalOnly, clientId)
                break
            case "Tags":
                setSelectedTags([])
                getAllowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, createdByUserId, createdBySource, [], globalOnly, clientId)
                break
            case "Global Only":
                setGlobalOnly(false)
                getAllowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, createdByUserId, createdBySource, selectedTags, false, clientId)
                break
            default:
                break
        }
        setPageNumber(0)
    }

    const handleFilterPillClose = closedLabel => {
        clearFilterByLabel(closedLabel)
        setAppliedFilters(prevState => {
            const updatedFilters = { ...prevState }
            if (closedLabel === "From" || closedLabel === "To" || closedLabel === "Date Range") {
                updatedFilters.From = null
                updatedFilters.To = null
                updatedFilters["Date Range"] = null
            } else if (closedLabel === "Client") {
                updatedFilters.Client = null
                updatedFilters.Site = null
            } else {
                updatedFilters[closedLabel] = null
            }
            return appliedFiltersUtilities.hasRemainingFilters(updatedFilters) ? updatedFilters : null
        })
    }

    const handleFilterPillItemRemove = (label, remainingIds) => {
        setAppliedFilters(prevState => appliedFiltersUtilities.keepMultiSelectionItems(prevState, label, remainingIds))
        removeMultiSelectFilterItemByLabel(label, remainingIds)
    }

    const removeMultiSelectFilterItemByLabel = (label, remainingIds) => {
        const sortPreference = stringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
        switch (label) {
            case "Tags":
                setSelectedTags(remainingIds)
                getAllowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, createdByUserId, createdBySource, remainingIds, globalOnly, clientId)
                break
            default:
                break
        }
        setPageNumber(0)
    }

    useEffect(() => {
        const sortPreference = stringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
        getAllowList(null, null, null, null, "0", sortPreference.sortBy, sortPreference.sortDirection, 0, null, null, selectedTags, false, null);
        Api.getAllowListCreatedBy(
            data => setCreatedByOptions(data),
            error => console.log(error),
            props.organisationId,
            props.token
        )
    }, []);

    var addNewUrl = "/organisation/" + props.organisationId + "/allowed-vrm";
    const handleCheckChange = (value) => {
        multiDeleteList.includes(value)
         ? setMultiDeleteList(prevState => prevState.filter(item => item !== value))
         : setMultiDeleteList(prevState => [...prevState, value]);
    }
    const handleMultiDeleteConfirm = () => {
        Api.deleteMultipleAllowListVrms(
            () => {
                setMultiDeleteList([]); 
                const sortPreference = stringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
                getAllowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, pageNumber, createdByUserId, createdBySource, selectedTags, globalOnly, clientId)
            },
            () => {},
            props.organisationId,
            multiDeleteList,
            props.token
        )
        setShowDeleteModal(false);
    }

    const handleSortTriggerClick = (sortBy, sortDirection) => {
        getAllowList(search, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortBy, sortDirection, pageNumber, createdByUserId, createdBySource, selectedTags, globalOnly, clientId);
        if (currentSortBy !== sortBy) {
            setCurrentSortBy(sortBy)
        }
    }

    return (     
        <div className="container-fluid">
            <div className="row">
                <div className="col-12">
                    <div className="card mb-3">
                        <div className="card-header">
                            <div className="d-flex align-items-center justify-content-between flex-wrap">
                                <div className="d-flex align-items-center pr-0">
                                    <h5 className="mb-0">Allow List</h5>
                                </div>
                                <div className="d-flex align-items-center justify-content-end pl-0">
                                    <div className='mr-2'>
                                        <SearchBarWithDebounce onSearchQueryChange={ query => {
                                        setSearch(query)
                                        setPageNumber(0)
                                        const sortPreference = stringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
                                        getAllowList(query, filterStart, filterEnd, !stringHelpers.isNullOrEmpty(siteId) ? siteId : null, filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, createdByUserId, createdBySource, selectedTags, globalOnly, clientId)
                                    } } />
                                    </div>
                                    <div className='mr-2'>
                                        <FiltersModalTrigger onClick={ () => setShowFiltersModal(true) } />
                                    </div>
                                    <div className='d-flex align-items-center'>
                                        {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) && 
                                        <>
                                            <Link className="btn btn-success btn-sm nowrap" to={ addNewUrl }><i className="fas fa-plus"></i> Add</Link>
                                            <Link className="btn btn-secondary btn-sm ml-1 nowrap" to={ `/organisation/${ props.organisationId }/allow-list/import` }><i className="fas fa-plus"></i> Import</Link>
                                        </>}
                                        <button className="btn btn-primary btn-sm ml-1 nowrap" onClick={() => exportToCSV()}>Export</button>
                                        <button
                                            onClick={ openScheduleExportModal }
                                            className="btn btn-sm btn-secondary nowrap ml-1"
                                        >
                                            Schedule Report<i className="ml-2 far fa-clock"></i>
                                        </button>
                                        {!isThirdPartyUser && !roleUtilities.isOrganisationProcessor(props.user, props.organisationId) &&
                                        <button
                                            disabled={!multiDeleteList || multiDeleteList.length === 0}
                                            onClick={() => setShowDeleteModal(true)}
                                            className="btn btn-danger btn-sm col-auto ml-1">
                                            <i className="fas fa-trash"></i> Delete
                                        </button>}
                                    </div>
                                </div>
                            </div>
                        </div>
                        {
                            showFilterPills && appliedFilters &&
                            <div className="px-3 py-2 border-top d-flex align-items-center flex-wrap">
                                {
                                    Object.entries(appliedFilters).map(
                                        ([label, value]) => <AppliedFilterPill
                                            key={ label }
                                            label={ label }
                                            value={ value }
                                            isLabelOnly={ label === "Global Only" }
                                            renderItemLabel={ renderTagFilterItemLabel }
                                            onTextClick={ () => setShowFiltersModal(true) }
                                            onCloseClick={ handleFilterPillClose }
                                            onRemoveItem={ handleFilterPillItemRemove }
                                        />
                                    )
                                }
                                {appliedFilters && Object.keys(appliedFilters).length > 0 && <button type="button" className="btn btn-none p-0 m-0 fs--1 nowrap" onClick={() => clearFilters()}>Clear all filters</button>}
                            </div>
                        }
                        <div className="card-body bg-light border-top p-0">
                            <table className="table table-sm mb-0 table-striped table-dashboard fs--1 data-table border-bottom border-200 no-footer allow-list-table">
                                <thead className="bg-200 text-900">
                                    <tr>
                                        {!isThirdPartyUser && <th>&nbsp;</th>}
                                        <th>                                          
                                            <ColumnSortTrigger 
                                                onClick={ direction => handleSortTriggerClick(0, direction)}
                                                currentSortBy={currentSortBy}
                                                sortBy={0}
                                                localStorageKey={`${props.user.id}-allowListSortPreference`}
                                                label="VRM"
                                            />
                                        </th>
                                        <th>&nbsp;</th>
                                        <th>Driver Name</th>
                                        <th>Vehicle</th>
                                        <th>Site(s)</th>
                                        <th>Site Group</th>
                                        <th>
                                            <ColumnSortTrigger 
                                                onClick={ direction => handleSortTriggerClick(1, direction) } 
                                                currentSortBy={currentSortBy}
                                                sortBy={1} 
                                                localStorageKey={`${props.user.id}-allowListSortPreference`}
                                                label="Start Date"
                                            />
                                        </th>
                                        <th>End Date</th>
                                        <th>
                                            <ColumnSortTrigger 
                                                onClick={ direction => handleSortTriggerClick(3, direction) }
                                                currentSortBy={currentSortBy}
                                                sortBy={3}
                                                localStorageKey={`${props.user.id}-allowListSortPreference`}
                                                label="Created Date"
                                            />
                                        </th>
                                        <th>Created By</th>
                                        <th>Validity</th>
                                        <th className='text-center'>Enabled</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        isLoading
                                        ? <tr><td colSpan={12}><Loader /></td></tr>
                                        : <>
                                            { 
                                            !arrayUtilities.isNullOrEmpty(allowList) && allowList
                                            .map((item, i) => {
                                            var url = "/organisation/" + props.organisationId + "/allowed-vrm/" + item.id;
                                                return (
                                                    <tr key={item.id} className='fs--2'>
                                                        {!isThirdPartyUser && 
                                                        <td>
                                                            <input
                                                                onChange={e => handleCheckChange(e.target.value)}
                                                                value={item.id}
                                                                type="checkbox"
                                                                id={item.id}
                                                                name={item.vrm}
                                                            />
                                                        </td>}
                                                        <td><Link to={url} className="number-plate-link"><h6 className="mb-0 compact-number-plate">{item.vrm}</h6></Link></td>
                                                        <td className="text-center">{
                                                                !stringHelpers.isNullOrEmpty(item.blueBadgeNumber) && <img width="20px" src='/assets/img/illustrations/wheelchair-symbol.svg' />
                                                            }
                                                        </td>
                                                        <td>{item.driverName}</td>
                                                        <td><div className='allow-list-clamped-cell'>{item.vehicleMake} {item.vehicleModel}</div></td>
                                                        <td>
                                                            {
                                                                !stringHelpers.isNullOrEmpty(item.siteName) 
                                                                ? <>{item.siteName}</>
                                                                : !stringHelpers.isNullOrEmpty(item.clientName) ? <>{item.clientName}</> : <>All</>
                                                            }
                                                        </td>
                                                        <td>{item.siteGroupName && <>{item.siteGroupName}</>}</td>
                                                        <td>
                                                            {
                                                                !stringHelpers.isNullOrEmpty(item.startDate) 
                                                                ? <>{toDateTimeString(item.startDate)} </> 
                                                                : <span>&mdash; </span>
                                                            }
                                                        </td>
                                                        <td>
                                                            {
                                                                !stringHelpers.isNullOrEmpty(item.endDate) 
                                                                ? <> {toDateTimeString(item.endDate)} <span className='text-end'>{isDateTimeElapsed(item.endDate) && <i className="fas fa-exclamation-triangle text-warning ml-2 fs-1"></i>}</span></>
                                                                : <span>&mdash; </span>
                                                            }
                                                        </td>
                                                        <td>{!stringHelpers.isNullOrEmpty(item.createdTimestamp) && toDateTimeString(item.createdTimestamp)}</td>
                                                        <td>{item.createdByUserName}</td>
                                                         <td>{ renderValidity(item) }
                                                        </td>
                                                        <td className='text-center'>
                                                            {
                                                                isThirdPartyUser || roleUtilities.isOrganisationProcessor(props.user, props.organisationId)
                                                                ? <>
                                                                    {item.isEnabled ? <i className="fas fa-check text-success"></i> : <i className="fas fa-times text-danger"></i>}
                                                                </>
                                                                : <ToggleWithLocalisedLoading 
                                                                checked={item.isEnabled} 
                                                                id={`${item.id}-enable-disable-allowed-vrm`}
                                                                onChange={isChecked => allowedVrmEnableDisable(item.id, isChecked, setErrorMessage, setAllowList, props.organisationId, props.token)}
                                                                loadingStateTracker={item}
                                                            />
                                                            }
                                                        </td>
                                                    </tr>
                                                )
                                        })}
                                        </>
                                    }
                                </tbody>
                            </table>
                        </div>
                        <Modal show={showDeleteModal} onHide={() => setShowDeleteModal(false)}>
                            <Modal.Header>
                                <Modal.Title>
                                    Delete {multiDeleteList.length} VRM{multiDeleteList.length > 1 ? "s" : ""}. Are you sure?
                                </Modal.Title>
                            </Modal.Header>
                            <Modal.Footer>
                                <button
                                    className="btn btn-sm btn-danger mt-1"
                                    onClick={() => setShowDeleteModal(false) }
                                >
                                    Cancel
                                </button>
                                <button
                                    className="btn btn-sm btn-success mt-1"
                                    onClick={handleMultiDeleteConfirm}
                                >
                                    Confirm
                                </button>
                            </Modal.Footer>
                        </Modal>
                        {
                            !stringHelpers.isNullOrEmpty(errorMessage) &&
                            <ErrorModal message={errorMessage} onHide={() => setErrorMessage(null)} />
                        }
                        {
                            showFiltersModal &&
                            <AllowListFiltersModal
                                showModal={showFiltersModal}
                                handleClose={() => setShowFiltersModal(false)}
                                handleConfirm={(draftFilters) => {
                                    setFilterStart(draftFilters.filterStart)
                                    setFilterEnd(draftFilters.filterEnd)
                                    setDatePreset(draftFilters.datePreset)
                                    setFilterPeriodType(draftFilters.filterPeriodType)
                                    setSiteId(draftFilters.siteId)
                                    setClientId(draftFilters.clientId)
                                    setSitesByClient(draftFilters.sitesByClient)
                                    setCreatedByUserId(draftFilters.createdByUserId)
                                    setCreatedBySource(draftFilters.createdBySource)
                                    setSelectedTags(draftFilters.selectedTags)
                                    setGlobalOnly(draftFilters.globalOnly)
                                    setAppliedFilters(draftFilters.appliedFilters)
                                    setShowFilterPills(true)
                                    setShowFiltersModal(false)
                                    setPageNumber(0);
                                    const sortPreference = stringHelpers.sortPreference(`${props.user.id}-allowListSortPreference`);
                                    getAllowList(search, draftFilters.filterStart, draftFilters.filterEnd, !stringHelpers.isNullOrEmpty(draftFilters.siteId) ? draftFilters.siteId : null, draftFilters.filterPeriodType, sortPreference.sortBy, sortPreference.sortDirection, 0, draftFilters.createdByUserId, draftFilters.createdBySource, draftFilters.selectedTags, draftFilters.globalOnly, draftFilters.clientId);
                                }}
                                initialFilterStart={filterStart}
                                initialFilterEnd={filterEnd}
                                initialDatePreset={datePreset}
                                initialFilterPeriodType={filterPeriodType}
                                initialSiteId={siteId}
                                initialClientId={clientId}
                                initialSitesByClient={sitesByClient}
                                initialCreatedByUserId={createdByUserId}
                                initialCreatedBySource={createdBySource}
                                initialSelectedTags={selectedTags}
                                initialAppliedFilters={appliedFilters}
                                initialGlobalOnly={globalOnly}
                                showSiteFilter
                                showClientsFilter
                                showTagsFilter
                                showGlobalFilter
                                sites={props.sites}
                                clients={props.clients}
                                createdByOptions={createdByOptions}
                                tags={props.tags || []}
                                organisationId={props.organisationId}
                                token={props.token}
                                key="allow-list-filters-modal"
                            />
                        }
                        { 
                            !isLoading && count !== null &&
                                <div className="card-footer border-top ">
                                    <div className="d-flex justify-content-center row align-items-center">
                                        <div className="col-auto align-items-center">
                                            <Pagination totalResults={count} currentPage={pageNumber} changePageNumber={changePageNumber} />
                                        </div>
                                    </div>
                                </div>
                        }
                    </div>
                </div>
            </div>
            {
                showScheduleExportModal &&
                <AllowListScheduleModal
                    sites={ props.sites }
                    clients={ props.clients }
                    tags={ props.tags || [] }
                    organisationId={ props.organisationId }
                    token={ props.token }
                    initialParameters={ scheduleInitialParameters }
                    initialSitesByClient={ sitesByClient }
                    onCancel={ closeScheduleExportModal }
                    onSaved={ closeScheduleExportModal }
                />
            }
        </div>
    )
}

export default AllowList;